import _ from "lodash";
import {getActionData} from "_helpers";
import {Auth} from "../components/Authorization";
import {metaConstants} from "../_constants";
import {metaService} from "../_services";
import {handleNoResultMessage} from "./utility.action";

function getFbPhotos(params) {
    return (dispatch) => {
        dispatch(getActionData(metaConstants.GET_FB_PHOTOS_REQUEST));
        metaService.getFbPhotos(params)
            .then(response => {
                dispatch(getActionData(metaConstants.GET_FB_PHOTOS_SUCCESS, response.data));
            }).catch((error) => {
            const status = _.get(error, 'response.status');
            if (status === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(metaConstants.GET_FB_PHOTOS_FAILURE, {}, error));
            handleNoResultMessage(error);
        });
    }
}

function getFbVideos(params) {
    return (dispatch) => {
        dispatch(getActionData(metaConstants.GET_FB_VIDEOS_REQUEST));
        metaService.getFbPhotos(params)
            .then(response => {
                dispatch(getActionData(metaConstants.GET_FB_VIDEOS_SUCCESS, response.data));
            }).catch((error) => {
            const status = _.get(error, 'response.status');
            if (status === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(metaConstants.GET_FB_VIDEOS_FAILURE, {}, error));
            handleNoResultMessage(error);
        });
    }
}

export const metaActions = {
    getFbPhotos,
    getFbVideos
}